import React from 'react';
export const EventHeaderSkeleton = () => {
  return (
    <div className='w-full flex bg-primary pt-10 pb-6 animate-pulse'>
      <div className='flex flex-col justify-between w-full px-4 xl:max-w-7xl mx-auto'>
        <div className='w-5 h-5 bg-surface-secondary mb-6'></div>
        <div className='flex items-center mb-6 h-4 bg-surface-secondary rounded-sm w-1/4'></div>
        <div className='flex gap-4 items-center mb-8'>
          <div className='w-12 h-14 md:w-16 md:h-16 relative shrink-0 bg-surface-secondary'></div>
          <div className='flex flex-col'>
            <div className='h-6 bg-surface-secondary rounded-sm w-32 mb-2'></div>
            <div className='h-4 bg-surface-secondary rounded-sm w-24'></div>
          </div>
        </div>
        <div className='flex gap-4'>
          <div className='h-10 bg-surface-secondary w-24 rounded-3xl'></div>
          <div className='h-10 bg-surface-secondary w-24 rounded-3xl'></div>
          <div className='h-10 bg-surface-secondary w-24 rounded-3xl'></div>
        </div>
      </div>
    </div>
  );
};
